import DOMPurify from 'dompurify';

const HTML_ALLOWED_TAGS = [
  'section', 'header', 'main', 'footer', 'article',
  'div', 'span', 'p',
  'h1', 'h2', 'h3', 'h4', 'h5', 'h6',
  'ul', 'ol', 'li',
  'table', 'thead', 'tbody', 'tr', 'th', 'td',
  'strong', 'em', 'b', 'i', 'small', 'br', 'hr', 'a'
];

const HTML_ALLOWED_ATTR = [
  'class', 'style', 'title', 'role',
  'aria-label', 'aria-hidden',
  'colspan', 'rowspan', 'scope',
  'href', 'target', 'rel'
];

const isSafeDisplayHref = (value) => {
  const href = String(value ?? '').trim();
  if (!href) return false;
  if (href.startsWith('//')) return false;
  if (/^[a-z][a-z0-9+.-]*:/i.test(href)) {
    return /^https?:/i.test(href);
  }
  return true;
};

export const sanitizeHtmlFragment = (html) => {
  const raw = String(html ?? '').trim();
  if (!raw) return '';

  const sanitized = DOMPurify.sanitize(raw, {
    ALLOWED_TAGS: HTML_ALLOWED_TAGS,
    ALLOWED_ATTR: HTML_ALLOWED_ATTR,
    FORBID_TAGS: ['script', 'style', 'iframe', 'form', 'input', 'button', 'svg', 'math', 'object', 'embed'],
    KEEP_CONTENT: true,
  });

  const template = document.createElement('template');
  template.innerHTML = sanitized;

  template.content.querySelectorAll('a[href]').forEach((anchor) => {
    const href = anchor.getAttribute('href');
    if (!isSafeDisplayHref(href)) {
      anchor.removeAttribute('href');
      anchor.removeAttribute('target');
      anchor.removeAttribute('rel');
      return;
    }

    if (anchor.getAttribute('target') === '_blank') {
      anchor.setAttribute('rel', 'noopener noreferrer');
    }
  });

  return template.innerHTML.trim();
};
